/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { toSafeString } from '@shared/utils';
import { WORKFLOW_STEP_ASK_COMPOSER_DRAFT_CONTEXT_KEY_PREFIX } from '@/lib/composer/pieveComposerDraftContext.js';
import { workflowStepTaskThreadId } from '@/redux/selectors/pieveSelectors/workflowStepTaskSelectors.js';

/* The thread a launcher or ask composer sends into, as far as this device knows it now: the task of the panel, page,
   report, data source or workflow step it asks about, or the person's companion for the read line. Each scope's send
   executor resolves the same thread on the server at send time; this is that thread when the store already holds it.
   '' for the scopes that create their thread on send (the home launcher and the analytics home launcher), and for a
   task the store has not loaded yet: those resolve as a composer with no thread, which is also how a new task runs.
   The model control reads it, so what the control shows is the run target the send resolves. */
export const launcherComposerThreadId = (state, scopeKey) => {
  const key = toSafeString(scopeKey);
  const idsAfter = (prefix) => (key.startsWith(prefix) ? key.slice(prefix.length).split(':') : null);
  const stepIds = idsAfter(WORKFLOW_STEP_ASK_COMPOSER_DRAFT_CONTEXT_KEY_PREFIX);

  if (stepIds) {
    return toSafeString(workflowStepTaskThreadId(state, { workflowId: stepIds[0], stepId: stepIds[1] }));
  }

  return '';
};
